import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import { timeStringFormat } from '@/common/lib/timer';
import { Glow } from '@/components/Shop/ui/ShopUi';
import { Picture } from '@/components/ui/Picture/Picture';
import { useModal } from '@/context/ModalContext';
import { getPaidRewardPlanCost } from '@/redux/selectors/earnRewardsSelector';
import { useAppSelector } from '@/redux/store';

import { useRewardTrackAvailable } from './useRewardTrack';

import css from './styles.module.scss';

import chevron from '/img/shop/v2/chevron.svg';
import trackPng from '/img/shop/v2/reward-track.png';
import trackWebp from '/img/shop/v2/reward-track.webp';

const RewardTrackBanner: FC = () => {
  const nextClaimTime = useAppSelector(
    (state) => state.earnRewards.rewards?.nextClaimTime,
  );
  const cost = useAppSelector(getPaidRewardPlanCost);
  const seconds = useCountDownTimer(nextClaimTime || 0);
  const { setEarnRewardModal } = useModal();
  const available = useRewardTrackAvailable();
  const { t } = useTranslation();

  if (!available) return null;

  return (
    <button
      type="button"
      className={css.banner}
      onClick={() => setEarnRewardModal(true)}
    >
      <Glow
        color="#82E024"
        blur={100}
        className="opacity-50 size-40 -left-[82px] -top-11"
      />
      <Glow
        color="#82E024"
        blur={100}
        className="w-[175px] h-[103px] left-[293px] -top-[55.5px]"
      />
      <div className={css.content}>
        <Picture
          img={trackPng}
          webp={trackWebp}
          alt=""
          className="block size-12 shrink-0 scale-[1.1189]"
        />
        <div className="flex flex-col gap-2 min-w-0 text-left">
          <span className={css.title}>
            {cost ? t('Epic Reward Track') : t('Reward Track')}
          </span>
          {!seconds ? (
            <span className={css.text}>
              {t('Your daily bonuses for 20 days!')}
            </span>
          ) : (
            <span className={css.timer}>
              {t('Next reward')}: {timeStringFormat(seconds * 1000)}
            </span>
          )}
        </div>
      </div>
      <img src={chevron} alt="" className="relative size-8 shrink-0" />
      {!seconds && <div className={css.dot} />}
    </button>
  );
};

export { RewardTrackBanner };
